import { CartPosition, DeliveryType, DeliveryAddress, DeliveryMethod } from "../types/cart.types";

// Wersja schematu zapisanego zamówienia.
// V2 = pozycje koszyka zawierają rozbicie dodatków z cenami (`additions`),
// dzięki czemu "ponów zamówienie" potrafi poprawnie przeliczyć cenę i nie
// gubi dodatków. Wpisy bez tej wersji (stary format V1) są niekompatybilne
// i muszą zostać usunięte — patrz `purgeOutdatedLastOrders`.
export const LAST_ORDER_VERSION = 2;

export interface LastOrder {
  version: number;
  cart: CartPosition[];
  deliveryType: DeliveryType;
  deliveryMethod?: DeliveryMethod | null;
  deliveryAdress?: DeliveryAddress | null;
  savedAt: number;
}

const STORAGE_PREFIX = "last_order_";

function storageKey(branchId: string): string {
  return `${STORAGE_PREFIX}${branchId}`;
}

export function saveLastOrder(
  branchId: string,
  order: Omit<LastOrder, "version">
): void {
  try {
    const versioned: LastOrder = { ...order, version: LAST_ORDER_VERSION };
    localStorage.setItem(storageKey(branchId), JSON.stringify(versioned));
  } catch {}
}

export function getLastOrder(branchId: string): LastOrder | null {
  try {
    const raw = localStorage.getItem(storageKey(branchId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Odrzuć stary/niekompatybilny format — tylko aktualna wersja jest ufana.
    if (parsed?.version !== LAST_ORDER_VERSION) return null;
    if (!parsed?.cart?.length) return null;
    return parsed as LastOrder;
  } catch {
    return null;
  }
}

/**
 * Usuwa z localStorage wszystkie zapisane zamówienia w nieaktualnej wersji
 * schematu (stary format bez rozbicia dodatków). Wywoływane raz przy starcie
 * aplikacji, żeby klienci z danymi sprzed wdrożenia nie ponawiali zamówień po
 * błędnej cenie.
 */
export function purgeOutdatedLastOrders(): void {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(STORAGE_PREFIX)) continue;
      try {
        const parsed = JSON.parse(localStorage.getItem(key) ?? "");
        if (parsed?.version !== LAST_ORDER_VERSION) {
          keysToRemove.push(key);
        }
      } catch {
        // Niepoprawny JSON pod kluczem last_order_ — też usuwamy.
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {}
}
